import { Component, OnInit } from '@angular/core';
import { RepurchaseService } from '../../../repurchase/services/repurchase.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
import { ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { ProductService } from '../../../products/services/product.service';
import { RepurchaseRenewalService } from '../../services/repurchase-renewal.service';
import { PersonService } from '../../../person/services/person.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UserService } from '../../../common/services/user.service';


declare let alasql;

@Component({
  selector: 'app-list-repurchase-renewal',
  templateUrl: './list-repurchase-renewal.component.html',
  styleUrls: ['./list-repurchase-renewal.component.css'],
  providers:[RepurchaseService,RepurchaseProductService,ProductService,RepurchaseRenewalService,PersonService,UserService]
})
export class ListRepurchaseRenewalComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  repurchaseRenewals:any = [];
  filters:any = {
    barcode:{contains: ""},
    total_purchase_amount: {contains: ""},
    total_due_amount:{contains: ""},
    status:{contains: ""},
    nif: {contains: ""},
    name: {contains: ""},
    surname: {contains: ""}
  };
  fromDate:any;
  untilDate:any;
  role:number = 3;
  exportParams:any ={};

  constructor(private repurchaseService: RepurchaseService,private route: ActivatedRoute,private router: Router, private repurchaseProductService:RepurchaseProductService, private userService:UserService,
              private productService:ProductService, private repurchaseRenewalService:RepurchaseRenewalService, private personService:PersonService,public toastr: ToastsManager, vcr: ViewContainerRef) { 
                this.toastr.setRootViewContainerRef(vcr);
              }

  ngOnInit() {
    this.getRepurchaseRenewals();
  }

  getRepurchaseRenewals(){
    var params = {
      where: _.cloneDeep(this.filters),
      sort: 'id DESC',
      skip: (this.p-1)*10,
      limit: 10
    };
    if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
        params.where.renewal_date = params.where.renewal_date? params.where.renewal_date:{};
        params.where.renewal_date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
        params.where.renewal_date = params.where.renewal_date? params.where.renewal_date:{};
        params.where.renewal_date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
    }
    this.exportParams = params;
    this.repurchaseRenewalService.query(params)
        .subscribe((repurchaseRenewals) => {
            let countParams = {
            where: _.cloneDeep(params.where),
            };
            this.repurchaseRenewalService.count(countParams)
            .subscribe((count) => {
            this.totalItems = count.count;
            });
            this.repurchaseRenewals = repurchaseRenewals;
            this.getRepurchasesProducts();
        });
  } 

  getRepurchasesProducts(){
    let params = {
      where: {
        repurchase_id: this.repurchaseRenewals.map(e => e.repurchase.id)
      }
    }
    this.repurchaseProductService.query(params)
    .subscribe((repurchaseProducts) => {
       let groupedRepurchaseProducts = _.groupBy(repurchaseProducts, (element)=> {return element.repurchase.id})
       this.repurchaseRenewals.forEach( (p) =>{
         if (groupedRepurchaseProducts[p.repurchase.id] && groupedRepurchaseProducts[p.repurchase.id].length > 0){
          this.parseProductsDescription(p, groupedRepurchaseProducts[p.repurchase.id]);
         }
       });
     });
  }

  parseProductsDescription(element, groupedProducts){
    element.productDescription = "";
    groupedProducts.forEach(products=>{
      if ((products.product.type!="1" && products.product.type!="4") || ((products.product.type=="1" || products.product.type=="4") && !products.product.sub_type)){
        element.productDescription += this.getNameProductType(products.product.type)+"- ";
      }
      if ((products.product.type=="1" || products.product.type=="4") && products.product.sub_type){
        element.productDescription += this.getNameSubType(products.product.sub_type,products.product.type)+"- ";
      }
      if (products.product.brand){
        element.productDescription += "Marca:"+products.product.brand+", ";
      }
      if (products.product.model){
        element.productDescription += "Modelo:"+products.product.model+", ";
      }
      if (products.product.telephone_company){
        element.productDescription += "Compañia:"+products.product.telephone_company+", ";
      }
      if (products.product.storage_capacity){
        element.productDescription += "Capacidad:"+products.product.storage_capacity+", ";
      }
      if (products.product.status){
        element.productDescription += "Estado:"+products.product.status+", ";
      }
      if (products.product.imei){
        element.productDescription += "Imei:"+products.product.imei+", ";
      }
      if (products.product.imei2){
        element.productDescription += "Imei2:"+products.product.imei2+", ";
      }
      if (products.product.so){
        element.productDescription += "Sistema Operativo:"+products.product.so+", ";
      }
      if (products.product.ram){
        element.productDescription += "Ram:"+products.product.ram+", ";
      }
      if (products.product.description){
        element.productDescription += "Descripción:"+products.product.description+", ";
      }
      if (products.product.serial_number){
        element.productDescription += "Número de serie:"+products.product.serial_number+", ";
      }
      if (products.product.type=="3"){
        element.productDescription +="Cantidad:"+products.product.stock+", ";       
      }
      element.productDescription = element.productDescription .slice(0, -2) + " / ";
    });
  }
  getNameProductType(type){
    var productType= ["Móviles y Tablets","Consolas","Artículos Varios","PC's-portátiles"];
    return productType[type-1];
  }

  getNameSubType(subType, type){
    let subTypes = ["",""];  
    if (type == 1){
      subTypes =["Móvil","Tablet"];
    }else if (type == 4){
      subTypes =["PC","Portatil"];
    }
    return subTypes[subType-1];
  }

  exportRepurchasesToExcel(){
    var options = {   
        fieldSeparator: ';',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: false,
        showTitle: false,
        useBom: false,   
        bookType:'xlsx' ,  
        cellStyles:true,
    };             
    let report = [
          {
              field1:"Nº de recompra",
              field2:"Fecha de renovación",
              field3:"NIF Cliente",
              field4:"Nº de renovación",
              field5:"Artículos",
              field6:"Base imponible",
              field7:"Porcentaje impuesto",
              field8:"Total"
              
          }
      ]
      delete this.exportParams.skip;
      delete this.exportParams.limit;
      this.repurchaseRenewalService.query(this.exportParams)
               .subscribe((repurchaseRenewals) => {
        let paramsProducts = {
            where: {
                repurchase_id: repurchaseRenewals.map(e => e.repurchase.id)
            }
        }
        this.repurchaseProductService.query(paramsProducts)
        .subscribe((repurchaseProducts) => {
            let groupedRepurchaseProducts = _.groupBy(repurchaseProducts, (element)=> {return element.repurchase.id})
            repurchaseRenewals.forEach( (p) =>{
                if (groupedRepurchaseProducts[p.repurchase.id] && groupedRepurchaseProducts[p.repurchase.id].length > 0){
                    this.parseProductsDescription(p, groupedRepurchaseProducts[p.repurchase.id]);
                }
            });
            repurchaseRenewals.forEach(repurchaseRenewal =>{                
              var row = {
                  field1:repurchaseRenewal.repurchase.id,
                  field2:repurchaseRenewal.renewal_date?moment(repurchaseRenewal.renewal_date).format("DD-MM-YYYY"):"",
                  field3:repurchaseRenewal.repurchase.nif,
                  field4:repurchaseRenewal.RepurchaseRenewalTickets[0]?repurchaseRenewal.RepurchaseRenewalTickets[0].number_with_serie:"",
                  field5:repurchaseRenewal.productDescription,
                  field6:repurchaseRenewal.partial_payment,
                  field7:"7%",
                  field8:repurchaseRenewal.RepurchaseRenewalTickets[0]?repurchaseRenewal.RepurchaseRenewalTickets[0].partial_payment_with_igic:"", 
              }
              report.push(row);
            });
            var mystyle = {   
                headers:true,       
                columns:    
                    [{columnid:'field1',width:50,title: ''},   
                    {columnid:'field2',width:100,title: ''},
                    {columnid:'field3',width:100,title: 'LISTADO DE RENOVACIONES'}, 
                    {columnid:'field4',width:100,title: ''},
                    {columnid:'field5',width:300,title: ''},
                    {columnid:'field6',width:100,title: ''},
                    {columnid:'field7',width:50,title: ''},
                    {columnid:'field8',width:50,title: ''}
                    
                    ],
                /*header*/
                
                column: {  
                    style:{
                        Alignment:{
                            Horizontal:"Center",
                            Vertical:"Center",  
                            WrapText:1
                            
                        },
                        Font:{
                            Bold:"1",
                            Color:"#000000",
                            Size:10
                        },
                        
                        Interior:{
                            Color:"#7CEECE",
                            Pattern:"Solid"
                        }
                    }},
                cells: {    
                    0:{
                        0:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid",
                                    },
                            Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",
                                WrapText: 1,
                                },  
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                            },                        
                            }  
                        },
                        1:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                    },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1, 
                        },  
                            Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },            
                                }
                        },
                        2:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                    },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1, 
                                    }, 
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                        }                
                                }
                            },
                        3:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                    },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1,
                                    },
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                        },            
                                    
                                }
                            },
                        4:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                    },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1, 
                                    },
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                        },                           
                                }
                            },
                        5:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                        },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1, 
                            },
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                        },                           
                                }
                            }, 
                        6:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                        },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1, 
                            },
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                        },                             
                            }
                            },
                        7:{style:{
                            Interior:{ 
                                Color:"#95a5a6",
                                Pattern:"Solid"
                                        },
                            Alignment:{
                                Horizontal: 'Center', 
                                Vertical: 'Center',
                                WrapText: 1,
                                    },
                            Font:{
                                Size:10,
                                Bold:"1",
                                Color:"#000000",
                        },              
                                }
                            },     
                    }   
                },
        };
        alasql.promise('SELECT * INTO XLSXML("Renovaciones_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
        .then(function(data){
            console.log('Data saved');
        }).catch(function(err){
            console.log('Error:', err);
        });
        });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/repurchase/components/list-repurchase-renewal/list-repurchase-renewal.component.ts